/* Cookie consent banner (RGPD compliant) */
(function () {
  'use strict';

  var banner = document.getElementById('cookie-banner');
  if (!banner) return;

  var COOKIE_NAME = 'intimum_cookie_consent';
  var settingsModal = document.getElementById('cookie-settings-modal');

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (getCookie(COOKIE_NAME)) {
    banner.remove();
    if (settingsModal) settingsModal.remove();
    return;
  }

  // Show after age gate closes (or immediately if no age gate)
  var delay = document.getElementById('age-gate') ? 2000 : 500;
  setTimeout(function () {
    banner.classList.add('is-visible');
  }, delay);

  document.getElementById('cookie-accept')?.addEventListener('click', function () {
    setCookie(COOKIE_NAME, 'all', 365);
    banner.classList.remove('is-visible');
    setTimeout(function () { banner.remove(); }, 500);
  });

  document.getElementById('cookie-reject')?.addEventListener('click', function () {
    setCookie(COOKIE_NAME, 'essential', 365);
    banner.classList.remove('is-visible');
    setTimeout(function () { banner.remove(); }, 500);
  });

  document.getElementById('cookie-settings-btn')?.addEventListener('click', function () {
    if (settingsModal) settingsModal.classList.add('is-active');
  });

  document.getElementById('cookie-settings-close')?.addEventListener('click', function () {
    if (settingsModal) settingsModal.classList.remove('is-active');
  });

  document.getElementById('cookie-save-preferences')?.addEventListener('click', function () {
    var analytics = document.getElementById('cookie-analytics')?.checked ? '1' : '0';
    var marketing = document.getElementById('cookie-marketing')?.checked ? '1' : '0';
    setCookie(COOKIE_NAME, 'custom_a' + analytics + '_m' + marketing, 365);
    if (settingsModal) settingsModal.classList.remove('is-active');
    banner.classList.remove('is-visible');
    setTimeout(function () { banner.remove(); }, 500);
  });
})();
